module.exports = "/templates/home.html";


//////////////////
// WEBPACK FOOTER
// ./src/templates/home.html
// module id = 451
// module chunks = 0